import api from './api'

// ⚠️ ENDPOINT REAL DE BIND - Backend hace proxy
// El backend llama a: POST https://api-pre.bind.com.ar/v1/banks/:bank_id/accounts/:account_id/:view_id/wallet/cvu
// Path params: bank_id=322, account_id=XX-X-XXXX-X-X, view_id=owner
// Body: { client_id: Number, cuit: String, name: String, currency: String }
export async function createCVU(cvuData) {
  const response = await api.post('/cvu/create', cvuData)
  return response.data
}

// Dar de baja CVU
// El backend llama a: DELETE https://api.bind.com.ar/v1/banks/:bank_id/accounts/:account_id/:view_id/wallet/cvu/:cvu/:cuit
export async function deleteCVU(data) {
  const response = await api.delete('/cvu/delete', { data })
  return response.data
}

// Listar CVUs dados de alta (activos)
// Obtiene la lista de CVUs dados de alta guardados en bind.db
export async function listCVUs() {
  const response = await api.get('/cvu/list')
  return response.data
}

